<template>
    <NuxtLink
        to="/"
        class="block w-full w-[7rem] xl:w-[9.5rem] aspect-w-2 aspect-h-1 bg-contain bg-center bg-no-repeat"
        :style="`background-image: url(${require(`~/assets/images/logos/logo-blue.png`)})`"
    >
    </NuxtLink>
</template>

<script>
export default {
    name: 'Logo',
};
</script>
